export default [
  "#dc4941", // Main Red
  "#444852", // Main Dark Blue
  "#b4bbcb", // Main Blue Grey
  "#6488ff", // Main Royal Blue
  "#41c49d", // Main Sea Green
  "#5c56e8", // Main Slate Blue
  "#e88e5e", // Main Sienna
  "#38699f", // Dark Royal Blue
  "#408182", // Dark Sea Green
  "#514b90", // Dark Slate Blue
  "#854b4b", // Dark Sienna
];
